import { Component, OnInit } from '@angular/core';
import {  Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  @Input() currentPage: number = 1;
  @Input() totalPages: number = 1;
  @Output() pageChange = new EventEmitter<number>();
  
  get visiblePages(): number[] {
    const maxVisiblePages = 5;
    const middlePage = Math.ceil(maxVisiblePages / 2);

    if (this.totalPages <= maxVisiblePages) {
      return Array.from({ length: this.totalPages }, (_, i) => i + 1);
    }

    if (this.currentPage <= middlePage) {
      return Array.from({ length: maxVisiblePages }, (_, i) => i + 1);
    }

    if (this.currentPage >= this.totalPages - middlePage + 1) {
      return Array.from({ length: maxVisiblePages }, (_, i) => this.totalPages - maxVisiblePages + 1 + i);
    }

    return Array.from({ length: maxVisiblePages }, (_, i) => this.currentPage - middlePage + 1 + i);
  }


  changePage(page: number): void {
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.pageChange.emit(page);
    }
  }
}